import { render, staticRenderFns } from "./CreateHaulageLeadTime.vue?vue&type=template&id=77467c26&scoped=true&"
import script from "./CreateHaulageLeadTime.vue?vue&type=script&lang=js&"
export * from "./CreateHaulageLeadTime.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77467c26",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VContainer,VForm})
